module.exports = __webpack_public_path__ + "static/media/caudalamap75.4655b244.gif";